/* World Spine Day — 场景轮播
   横向滚动 + scroll-snap 由 CSS 负责；这里只处理左右箭头：每次滚动一张卡的距离，到头时禁用对应箭头。 */
(function () {
  function init(root) {
    var track = root.querySelector('[data-wsd-track]');
    var prev = root.querySelector('[data-wsd-prev]');
    var next = root.querySelector('[data-wsd-next]');
    if (!track || root.dataset.wsdReady) return;
    root.dataset.wsdReady = 'true';

    function step() {
      var slide = track.querySelector('.wsd-slide');
      if (!slide) return track.clientWidth;
      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max - 2;
      root.classList.toggle('wsd-carousel--static', max <= 2);
    }

    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wsd-carousel]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  // 主题编辑器里改设置会重新渲染 section
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();

/* World Spine Day — Set 加购区
   1) 顶部按钮切换 bundle 面板（S2 + M3 / S1 + M3）
   2) 切颜色时更新「省多少」和「用码后到手价」（每个变体的文案已由 Liquid 算好放在 data-wsd-deals）
   3) 一键复制折扣码（data-wsd-copy）；剪贴板不可用时把码显示在按钮上，让顾客手动抄
   都用事件委托挂在 document 上，编辑器重新渲染 section 后不用重新绑定。 */
(function () {
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-wsd-set-tab]');
    if (tab) {
      var root = tab.closest('[data-wsd-set]');
      if (!root) return;
      var id = tab.dataset.wsdSetTab;
      root.querySelectorAll('[data-wsd-set-panel]').forEach(function (p) {
        p.hidden = p.dataset.wsdSetPanel !== id;
      });
      root.querySelectorAll('[data-wsd-set-tab]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.dataset.wsdSetTab === id ? 'true' : 'false');
      });
      // 焦点跟到新面板里同一个按钮上，键盘用户不会丢位置
      var same = root.querySelector('[data-wsd-set-panel="' + id + '"] [data-wsd-set-tab="' + id + '"]');
      if (same && document.activeElement === tab) same.focus();
      return;
    }

    var swatch = e.target.closest('.wsd-set-panel .fs-swatch');
    if (swatch && !swatch.disabled) {
      var panel = swatch.closest('[data-wsd-set-panel]');
      var deals;
      try { deals = JSON.parse(panel.dataset.wsdDeals || '{}'); } catch (err) { deals = {}; }
      var d = deals[swatch.dataset.variantId];
      if (!d) return;
      var save = panel.querySelector('.wsd-set-save');
      if (save) { save.textContent = d.save; save.hidden = !d.save; }
      var fin = panel.querySelector('[data-wsd-final]');
      if (fin) fin.textContent = d.final;
      return;
    }

    var copy = e.target.closest('[data-wsd-copy]');
    if (copy) {
      var code = copy.dataset.wsdCopy;
      var label = copy.querySelector('[data-wsd-copy-label]');
      var flash = function (text, cls) {
        if (!label) return;
        label.textContent = text;
        copy.classList.add(cls);
        clearTimeout(copy._wsdTimer);
        copy._wsdTimer = setTimeout(function () {
          label.textContent = code;
          copy.classList.remove('is-copied', 'is-revealed');
        }, 2500);
      };
      var done = function () { flash(copy.dataset.labelCopied || 'Code Copied', 'is-copied'); };
      var fail = function () { flash(code, 'is-revealed'); };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(code).then(done, fail);
      } else {
        fail();
      }
    }
  });
})();

/* World Spine Day — 悬停图按需加载
   .fs-hover-img 只在鼠标悬停卡片时淡入（样式见 fall-sale.css）。触屏设备永远触发不了，
   所以 Liquid 不给它 src，只留 data-hover-src；这里判断设备支持悬停才真正去下载。
   手机上因此少下 3 张大图。 */
(function () {
  var mq = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');

  function canHover() { return !mq || mq.matches; }

  function load(scope) {
    if (!canHover()) return;
    (scope || document).querySelectorAll('.fs-hover-img[data-hover-src]').forEach(function (img) {
      img.src = img.dataset.hoverSrc;
      img.removeAttribute('data-hover-src');
    });
  }

  load();

  // 接上鼠标 / 从手机视图切回桌面视图时再补上
  if (mq && typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', function () { load(); });
  }
  // 主题编辑器重新渲染 section 后，新节点里的图也要处理
  document.addEventListener('shopify:section:load', function (e) { load(e.target); });
})();

/* World Spine Day — 折叠线下的图片/视频封面真正按滚动加载
   原生 loading="lazy" 在慢网下的触发距离很大（Chrome 约 3000px），
   实测这页折叠线下的 8 张图 + 2 张视频封面（合计约 580KB）全都在首屏一起下了，
   和横幅图抢带宽，LCP 因此卡在 7 秒。这里用 IntersectionObserver 自己控距离。

   约定：元素带 data-wsd-lazy，图片用 data-src / data-srcset，视频封面用 data-poster。
   没有 IntersectionObserver 的老浏览器直接全部加载；禁用 JS 的情况由 <noscript> 兜底。 */
(function () {
  var SEL = '[data-wsd-lazy]';

  function reveal(el) {
    if (el.tagName === 'VIDEO') {
      if (el.dataset.poster) { el.poster = el.dataset.poster; delete el.dataset.poster; }
    } else {
      // 切颜色时 fall-sale.js 会直接写 src；已经有 src 就别再用原始图盖回去
      if (!el.getAttribute('src')) {
        if (el.dataset.srcset) el.srcset = el.dataset.srcset;
        if (el.dataset.src) el.src = el.dataset.src;
      }
      delete el.dataset.src;
      delete el.dataset.srcset;
    }
    el.removeAttribute('data-wsd-lazy');
  }

  function observe(scope) {
    var nodes = (scope || document).querySelectorAll(SEL);
    if (!nodes.length) return;

    if (!('IntersectionObserver' in window)) {
      nodes.forEach(reveal);
      return;
    }

    var io = new IntersectionObserver(function (entries, self) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        self.unobserve(entry.target);
        reveal(entry.target);
      });
      // 横向也留出余量：场景图在横向轮播里，右侧还没露出的那几张要提前备好，
      // 否则点箭头切过去会看到空白
    }, { rootMargin: '400px 600px' });

    nodes.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { observe(); });
  } else {
    observe();
  }
  document.addEventListener('shopify:section:load', function (e) { observe(e.target); });

  /* 切 bundle 面板时立刻补图。
     隐藏面板（hidden → display:none）里的元素面积为 0，观察器永远不会触发，
     不补的话用户点过去会先看到空白卡片。 */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest && e.target.closest('[data-wsd-set-tab]');
    if (!tab) return;
    var root = tab.closest('[data-wsd-set]');
    if (!root) return;
    // 等同一轮里负责切面板的监听器先把 hidden 去掉
    setTimeout(function () {
      root.querySelectorAll('[data-wsd-set-panel]:not([hidden]) ' + SEL).forEach(reveal);
    }, 0);
  });
})();
